(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rosygrace-collection-discovery"] && !Shopify.designMode) return;
  try {
    
(() => {
  function setup(scope) {
    scope.querySelectorAll('[data-rgs-stones]').forEach(group => {
      const input = group.querySelector('[data-rgs-stone-search]');
      if (!input || input.dataset.ready) return;
      input.dataset.ready = 'true';
      group.querySelector('.rgs-stone-search').hidden = false;
      input.addEventListener('input', () => {
        const term = input.value.trim().toLocaleLowerCase();
        let count = 0;
        group.querySelectorAll('.rgs-filter-options > span').forEach(option => {
          option.hidden = !option.textContent.toLocaleLowerCase().includes(term);
          if (!option.hidden) count++;
        });
        group.querySelector('[data-rgs-no-stones]').hidden = count > 0;
      });
    });
  }
  setup(document);
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rosygrace-header"] && !Shopify.designMode) return;
  try {
    
const rosyGracePreviewId = new URL(location.href).searchParams.get('preview_theme_id');
if (rosyGracePreviewId && /^\d+$/.test(rosyGracePreviewId)) {
  function rosyGracePreviewUrl(href) {
    const url = new URL(href, location.href);
    if (url.origin !== location.origin || !/^\/(?:$|collections(?:\/|$)|products(?:\/|$)|pages(?:\/|$)|policies(?:\/|$)|cart(?:\/|$)|search(?:\/|$))/.test(url.pathname)) return href;
    url.searchParams.set('preview_theme_id', rosyGracePreviewId);
    return url.pathname + url.search + url.hash;
  }
  function rosyGracePreviewLinks() {
    document.querySelectorAll('a[href]').forEach(function(anchor) {
      const href = anchor.getAttribute('href');
      if (!href || href.startsWith('#') || /^(?:mailto:|tel:)/i.test(href)) return;
      anchor.setAttribute('href', rosyGracePreviewUrl(href));
    });
    document.querySelectorAll('form[method="get"]').forEach(function(form) {
      if (form.querySelector('input[name="preview_theme_id"]')) return;
      const input = document.createElement('input');
      input.type = 'hidden'; input.name = 'preview_theme_id'; input.value = rosyGracePreviewId; form.append(input);
    });
    if (window.routes && window.routes.cart_url) window.routes.cart_url = rosyGracePreviewUrl(window.routes.cart_url);
  }
  rosyGracePreviewLinks();
  document.addEventListener('shopify:section:load', rosyGracePreviewLinks);
  document.addEventListener('click', function(event) {
    const anchor = event.target.closest('a[href]');
    if (anchor && !anchor.getAttribute('href').startsWith('#')) anchor.href = rosyGracePreviewUrl(anchor.href);
  }, true);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rosygrace-homepage"] && !Shopify.designMode) return;
  try {
    
function openRosyGraceAnchor() {
  const id = location.hash.slice(1);
  if (!id.startsWith('rg-')) return;
  const target = document.getElementById(id);
  if (target && target.tagName === 'DETAILS') target.open = true;
}
window.addEventListener('hashchange', openRosyGraceAnchor);
document.addEventListener('click', function(event) {
  const anchor = event.target.closest('a[href^="#rg-"]');
  if (!anchor) return;
  const target = document.getElementById(anchor.hash.slice(1));
  if (target && target.tagName === 'DETAILS') target.open = true;
});
openRosyGraceAnchor();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rosygrace-reference-footer"]) return;
  try {
    
  function revealRosyGraceNewsletterResult() {
    const result = document.querySelector('[data-rgr-newsletter-result]');
    if (!result) return;
    const details = result.closest('details');
    if (details) details.open = true;
    result.focus();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', revealRosyGraceNewsletterResult, {once:true});
  else revealRosyGraceNewsletterResult();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rosygrace-shopping-tools"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.getElementById('rgs-shopping-strings');
  if (!root) return;
  const strings = JSON.parse(root.textContent);
  const key = 'rosygrace_wishlist_v1';
  let saved = [];
  try {
    const value = JSON.parse(localStorage.getItem(key) || '[]');
    if (Array.isArray(value)) saved = value.filter(item => typeof item === 'string' && /^[a-z0-9-]+$/.test(item)).slice(0,100);
  } catch {}
  const status = document.getElementById('rgs-status');
  const dialog = document.getElementById('rgs-wishlist');
  const opener = document.getElementById('rgs-open-wishlist');
  const icons = document.querySelector('.header__icons');
  if (opener && icons) icons.prepend(opener);
  let renderVersion = 0;
  function sync() {
    document.querySelectorAll('[data-rgs-save]').forEach(button => {
      const active = saved.includes(button.dataset.rgsSave);
      button.setAttribute('aria-pressed', String(active));
      const label = button.querySelector('span');
      const nextLabel = active ? strings.saved : strings.save;
      if (label && label.textContent !== nextLabel) label.textContent = nextLabel;
    });
    const count = document.querySelector('.rgs-wishlist-count');
    if (count) { count.textContent = saved.length; count.hidden = !saved.length; }
  }
  function persist() {
    try { localStorage.setItem(key, JSON.stringify(saved)); return true; }
    catch { status.textContent = strings.storage_error; return false; }
  }
  function money(value) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en-SG', {style:'currency',currency:strings.currency,currencyDisplay:'narrowSymbol'}).format(value / 100) + ' ' + strings.currency;
  }
  function node(tag, value, className) {
    const result = document.createElement(tag);
    if (value) result.textContent = value;
    if (className) result.className = className;
    return result;
  }
  async function drawWishlist() {
    const host = document.getElementById('rgs-wishlist-items');
    if (!host) return;
    const version = ++renderVersion;
    host.replaceChildren(node('p', saved.length ? strings.loading : strings.empty));
    if (!saved.length) return;
    const handles = [...saved];
    const result = await Promise.all(handles.map(async handle => {
      try {
        const response = await fetch(strings.root + 'products/' + encodeURIComponent(handle) + '.js', {credentials:'same-origin'});
        if (!response.ok) throw new Error();
        return {handle,product:await response.json()};
      } catch { return {handle,product:null}; }
    }));
    if (version !== renderVersion) return;
    host.replaceChildren();
    result.forEach(item => {
      const row = node('article', '', 'rgs-wishlist-item');
      const url = strings.root + 'products/' + item.handle;
      const product = item.product;
      if (product && product.featured_image) {
        const img = node('img');
        const src = new URL(product.featured_image, location.origin);
        if (src.protocol === 'https:') { src.searchParams.set('width','200'); img.src = src.href; }
        img.alt = product.title; img.loading = 'lazy'; row.append(img);
      } else row.append(node('span'));
      const copy = node('div');
      const link = node('a', product ? product.title : item.handle.replace(/-/g,' '));
      link.href = url;
      copy.append(link);
      copy.append(node('p', product ? (product.available ? (product.price_varies ? strings.from + ' ' : '') + money(product.price) : strings.sold_out) : strings.unavailable));
      const remove = node('button',strings.remove);
      remove.setAttribute('aria-label', strings.remove + ' ' + link.textContent);
      remove.type = 'button'; remove.dataset.rgsRemove = item.handle; copy.append(remove); row.append(copy); host.append(row);
    });
  }
  document.addEventListener('click', event => {
    const save = event.target.closest('[data-rgs-save]');
    if (save) {
      event.preventDefault();
      const handle = save.dataset.rgsSave;
      const old = [...saved];
      saved = saved.includes(handle) ? saved.filter(item => item !== handle) : [...saved, handle].slice(-100);
      if (!persist()) saved = old;
      else status.textContent = saved.includes(handle) ? strings.saved : strings.remove;
      sync();
    }
    const remove = event.target.closest('[data-rgs-remove]');
    if (remove) {
      const old = [...saved]; saved = saved.filter(item => item !== remove.dataset.rgsRemove);
      if (!persist()) saved = old;
      sync();
      if (document.activeElement === remove && dialog) dialog.querySelector('[data-rgs-close]').focus();
      drawWishlist();
    }
  });
  if (opener && dialog) {
    opener.addEventListener('click', () => { dialog.showModal(); drawWishlist(); });
    dialog.querySelector('[data-rgs-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if(event.target === dialog) {const rect = dialog.getBoundingClientRect(); if(event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();} });
    dialog.addEventListener('close', () => opener.focus());
  }
  window.addEventListener('storage', event => {
    if (event.key !== key) return;
    try { const value = JSON.parse(event.newValue || '[]'); if(Array.isArray(value)) saved = value.filter(item => typeof item === 'string' && /^[a-z0-9-]+$/.test(item)).slice(0,100); } catch {}
    sync(); if(dialog && dialog.open) drawWishlist();
  });
  sync();
  document.addEventListener('shopify:section:load', sync);
  const grid = document.getElementById('ProductGridContainer');
  if (grid) new MutationObserver(sync).observe(grid,{childList:true,subtree:true});
  const sticky = document.getElementById('rgs-sticky-cart');
  const info = document.querySelector('product-info[id^="MainProduct-"]');
  if (sticky && info) {
    const variants = JSON.parse(document.getElementById('rgs-variants').textContent);
    const button = sticky.querySelector('[data-rgs-add]');
    let scheduled = false;
    function scheduleSticky() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => { scheduled = false; syncSticky(); });
    }
    function syncSticky() {
      const submit = info.querySelector('product-form button[name="add"]');
      const id = info.querySelector('product-form input[name="id"]');
      const variant = variants.find(item => String(item.id) === (id && id.value));
      if (!submit) { sticky.hidden = true; return; }
      button.disabled = submit.disabled || submit.getAttribute('aria-disabled') === 'true';
      const label = submit.querySelector('span');
      const busy = submit.classList.contains('loading');
      button.textContent = busy ? strings.adding : label ? label.textContent.trim() : submit.textContent.trim();
      button.setAttribute('aria-busy', String(busy));
      sticky.querySelector('[data-rgs-price]').textContent = variant ? money(variant.price) : '';
      sticky.hidden = submit.getBoundingClientRect().bottom > 0 || !!document.querySelector('cart-drawer.active,.cart-notification.active,details-modal details[open],menu-drawer details[open],header-drawer details[open],dialog[open],product-modal[open]');
    }
    new MutationObserver(scheduleSticky).observe(info,{childList:true,subtree:true,attributes:true,attributeFilter:['disabled','value','aria-disabled','class']});
    document.querySelectorAll('cart-drawer,.cart-notification,details-modal details,menu-drawer details,header-drawer details,dialog,product-modal').forEach(overlay => {
      new MutationObserver(scheduleSticky).observe(overlay,{attributes:true,attributeFilter:['class','open']});
    });
    window.addEventListener('scroll',scheduleSticky,{passive:true});
    window.addEventListener('resize',scheduleSticky,{passive:true});
    window.addEventListener('pageshow',scheduleSticky);
    button.addEventListener('click', () => {
      const submit = info.querySelector('product-form button[name="add"]');
      if (!submit || submit.disabled || submit.getAttribute('aria-disabled') === 'true' || !submit.form) return;
      if (!submit.form.checkValidity()) {
        const invalid = submit.form.querySelector(':invalid');
        if (invalid) { invalid.scrollIntoView({block:'center'}); invalid.focus({preventScroll:true}); }
        submit.form.reportValidity();
        return;
      }
      submit.click();
    });
    syncSticky();
  }
  document.addEventListener('submit', event => {
    const form = event.target;
    if (form.matches('form[data-type="add-to-cart-form"]') && !form.reportValidity()) {event.preventDefault();event.stopImmediatePropagation();}
  },true);
  const requested = new URL(location.href).searchParams.get('product');
  const productField = document.getElementById('rgs-product');
  if (productField && requested && /^[a-z0-9-]+$/.test(requested) && !productField.value) productField.value = location.origin + strings.root + 'products/' + requested;
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rosygrace-stone-library"] && !Shopify.designMode) return;
  try {
    
(() => {
  const mount = (root) => {
    if (root.dataset.rglReady) return;
    const payload = root.querySelector('[data-rgl-data]');
    if (!payload) return;
    let data;
    try { data = JSON.parse(payload.textContent); } catch { return; }
    root.dataset.rglReady = 'true';
    const t = data.strings;
    const byId = new Map(data.stones.map(stone => [stone.id, stone]));
    const combinations = new Map(data.combinations.map(combo => [combo.id, combo]));
    const q = selector => root.querySelector(selector);
    const all = selector => [...root.querySelectorAll(selector)];
    const clean = value => String(value || '').normalize('NFKC').toLocaleLowerCase().trim();
    const interpolate = (value, vars = {}) => Object.entries(vars).reduce((text, [key, val]) => text.replaceAll(`{${key}}`, String(val)), value);
    const form = q('.rgl__form');
    const brief = q('[data-rgl-brief]');
    const fields = new Map(all('[data-rgl-preference]').map(field => [field.dataset.rglPreference, field]));
    const selectedContainer = q('[data-rgl-selected]');
    const selectedField = q('[data-rgl-stones-field]');
    const meaningsField = q('[data-rgl-meanings-field]');
    const live = q('[data-rgl-live]');
    const wa = q('[data-rgl-whatsapp]');
    let selected = [];
    let visibleLimit = 12;
    let briefEdited = brief.value.trim().length > 0;
    let briefStale = briefEdited;
    let previousBrief = '';
    let storageOK = true;
    const storageKey = 'rosygrace-stone-library-selection-v1';
    const element = (tag, className, text) => {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (text) node.textContent = text;
      return node;
    };
    const report = message => { live.textContent = message; };
    try {
      const saved = JSON.parse(localStorage.getItem(storageKey) || '[]');
      if (Array.isArray(saved)) selected = [...new Set(saved.filter(id => typeof id === 'string' && byId.has(id)))].slice(0, 3);
    } catch { storageOK = false; }
    const save = () => {
      try { localStorage.setItem(storageKey, JSON.stringify(selected)); } catch { storageOK = false; }
      q('[data-rgl-storage]').textContent = storageOK ? t.storage_note : t.storage_unavailable;
    };
    const selectedStones = () => selected.map(id => byId.get(id));
    const matchingCombination = () => data.combinations.find(combo => combo.stones.length === selected.length && combo.stones.every(id => selected.includes(id)));
    const flagMessages = () => data.careFlags.filter(flag => flag.stones.some(id => selected.includes(id))).map(flag => flag.message);
    const preferenceText = key => {
      const field = fields.get(key);
      if (!field) return '';
      return field.tagName === 'SELECT' ? field.selectedOptions[0].textContent : field.value.trim();
    };
    const makeBrief = () => {
      const lines = [t.brief_heading, '', t.brief_stones];
      selectedStones().forEach(stone => {
        lines.push(`• ${stone.name} (${stone.zh})`);
        lines.push(`  ${t.brief_symbolism}: ${stone.meaning}`);
      });
      if (!selected.length) lines.push(t.brief_empty);
      const matching = matchingCombination();
      if (matching) lines.push('', `${t.combination_story}: ${matching.name}`, matching.story);
      lines.push('', t.brief_preferences);
      for (const [key, field] of fields) {
        if (key === 'notes' || !field.value.trim()) continue;
        lines.push(`${t[`field_${key}`]}: ${preferenceText(key)}${key === 'budget' ? ' SGD' : key === 'wrist' ? ' cm' : ''}`);
      }
      if (fields.get('notes').value.trim()) lines.push('', t.brief_notes, fields.get('notes').value.trim());
      const flags = flagMessages();
      if (flags.length) lines.push('', t.brief_care, ...flags.map(message => `• ${message}`));
      lines.push('', t.brief_boundary, t.quote_note);
      return lines.join('\n');
    };
    const updateHandoff = (changed = false) => {
      if (changed && briefEdited) {
        briefStale = true;
        q('[data-rgl-review]').checked = false;
      }
      q('[data-rgl-review-wrap]').hidden = !briefStale;
      q('[data-rgl-review]').required = briefStale;
      const stones = selectedStones();
      selectedField.value = stones.map(stone => `${stone.name} (${stone.zh})`).join(' + ');
      meaningsField.value = stones.map(stone => `${stone.name}: ${stone.meaning}`).join('\n');
      if (!briefEdited) brief.value = makeBrief();
      if (selected.length) {
        const message = briefEdited ? `${makeBrief()}\n\n${t.brief_edited}\n${brief.value}` : makeBrief();
        wa.href = `https://wa.me/6596959803?text=${encodeURIComponent(message)}`;
        wa.removeAttribute('aria-disabled');
      } else {
        wa.removeAttribute('href');
        wa.setAttribute('aria-disabled', 'true');
      }
    };
    const renderSelection = () => {
      selectedContainer.replaceChildren();
      q('[data-rgl-selection-count]').textContent = interpolate(t.selected_count, { count: selected.length });
      if (!selected.length) selectedContainer.append(element('p', '', t.selection_empty));
      const matching = matchingCombination();
      if (matching) {
        const story = element('div', 'rgl__care-notes');
        story.dataset.rglSymbolic = '';
        story.hidden = q('[data-rgl-facts]').checked;
        story.append(element('h4', '', t.combination_story), element('p', 'rgl__small', matching.story));
        selectedContainer.append(story);
      }
      selectedStones().forEach(stone => {
        const card = element('article', 'rgl__selected-stone');
        card.append(element('h4', '', stone.name), element('p', '', stone.zh));
        const meaning = element('p', '', stone.meaning);
        meaning.dataset.rglSymbolic = '';
        meaning.hidden = q('[data-rgl-facts]').checked;
        card.append(meaning, element('p', 'rgl__care', stone.suitability));
        const remove = element('button', 'rgl__text-button', interpolate(t.remove_stone, { stone: stone.name }));
        remove.type = 'button';
        remove.dataset.rglRemove = stone.id;
        card.append(remove);
        selectedContainer.append(card);
      });
      const flags = flagMessages();
      if (flags.length) {
        const warnings = element('div', 'rgl__care-notes');
        warnings.append(element('h4', '', t.care_flags_title));
        flags.forEach(message => warnings.append(element('p', 'rgl__small', message)));
        selectedContainer.append(warnings);
      }
      all('[data-rgl-add]').forEach(button => {
        const included = selected.includes(button.dataset.rglAdd);
        button.textContent = included ? t.added : t.add;
        button.setAttribute('aria-pressed', String(included));
      });
      q('[data-rgl-clear]').disabled = selected.length === 0;
      save();
      updateHandoff(true);
    };
    const filter = (reset = true) => {
      if (reset) visibleLimit = 12;
      const query = clean(q('[data-rgl-search]').value);
      const intention = q('[data-rgl-intention]').value;
      const colour = q('[data-rgl-colour]').value;
      let count = 0;
      all('[data-rgl-stone]').forEach(card => {
        const stone = byId.get(card.dataset.rglStone);
        const matches = (!query || stone.search.includes(query)) && (!intention || stone.intentions.includes(intention)) && (!colour || stone.colours.includes(colour));
        if (matches) count++;
        card.hidden = !matches || count > visibleLimit;
      });
      q('[data-rgl-results]').textContent = interpolate(t.results_count, { count, shown: Math.min(count, visibleLimit), total: data.stones.length });
      q('[data-rgl-no-results]').hidden = count !== 0;
      q('[data-rgl-more]').hidden = count <= visibleLimit;
      const ambiguities = data.ambiguities.filter(entry => clean(entry.term) === query).map(entry => entry.note);
      q('[data-rgl-ambiguity]').textContent = ambiguities.join(' ');
      q('[data-rgl-ambiguity]').hidden = !ambiguities.length;
    };
    const toggleFacts = () => {
      const facts = q('[data-rgl-facts]').checked;
      all('[data-rgl-symbolic]').forEach(node => { node.hidden = facts; });
    };
    q('[data-rgl-search]').addEventListener('input', filter);
    q('[data-rgl-intention]').addEventListener('change', filter);
    q('[data-rgl-colour]').addEventListener('change', filter);
    q('[data-rgl-facts]').addEventListener('change', toggleFacts);
    q('.rgl__jump a[href="#rgl-combinations"]').addEventListener('click', () => {
      q('[data-rgl-facts]').checked = false;
      toggleFacts();
    });
    q('[data-rgl-more]').addEventListener('click', () => {
      const previouslyVisible = all('[data-rgl-stone]').filter(card => !card.hidden).length;
      visibleLimit += 12;
      filter(false);
      const newCard = all('[data-rgl-stone]').filter(card => !card.hidden)[previouslyVisible];
      if (newCard) {
        const heading = newCard.querySelector('h3');
        heading.setAttribute('tabindex', '-1');
        heading.focus();
      }
    });
    q('[data-rgl-reset]').addEventListener('click', () => {
      q('[data-rgl-search]').value = '';
      q('[data-rgl-intention]').value = '';
      q('[data-rgl-colour]').value = '';
      q('[data-rgl-facts]').checked = false;
      filter();
      toggleFacts();
      q('[data-rgl-search]').focus();
    });
    root.addEventListener('click', event => {
      const add = event.target.closest('[data-rgl-add]');
      const remove = event.target.closest('[data-rgl-remove]');
      const choose = event.target.closest('[data-rgl-combination]');
      if (add) {
        const id = add.dataset.rglAdd;
        if (selected.includes(id)) {
          report(interpolate(t.already_added, { stone: byId.get(id).name }));
          return;
        }
        if (selected.length >= 3) { report(t.maximum); live.scrollIntoView({ block: 'nearest', behavior: 'auto' }); return; }
        selected.push(id);
        renderSelection();
        report(interpolate(t.stone_added, { stone: byId.get(id).name, count: selected.length }) + (briefEdited ? ` ${t.edits_kept}` : ''));
      }
      if (remove) {
        const id = remove.dataset.rglRemove;
        selected = selected.filter(stone => stone !== id);
        renderSelection();
        report(interpolate(t.stone_removed, { stone: byId.get(id).name }) + (briefEdited ? ` ${t.edits_kept}` : ''));
        const next = selectedContainer.querySelector('button') || q('[data-rgl-clear]');
        if (!next.disabled) next.focus();
        else q('.rgl__selection-actions a').focus();
      }
      if (choose) {
        const combination = combinations.get(choose.dataset.rglCombination);
        selected = [...new Set(combination.stones.filter(id => byId.has(id)))].slice(0, 3);
        if (combination.display) fields.get('format').value = 'display';
        renderSelection();
        report(interpolate(t.combination_selected, { name: combination.name }) + (briefEdited ? ` ${t.edits_kept}` : ''));
        q('#build-your-piece').scrollIntoView({ block: 'start', behavior: 'auto' });
        q('#rgl-builder-title').setAttribute('tabindex', '-1');
        q('#rgl-builder-title').focus({ preventScroll: true });
      }
    });
    q('[data-rgl-clear]').addEventListener('click', () => {
      selected = [];
      renderSelection();
      report(t.selection_cleared + (briefEdited ? ` ${t.edits_kept}` : ''));
      q('.rgl__selection-actions a').focus();
    });
    fields.forEach(field => {
      field.addEventListener('input', () => updateHandoff(true));
      field.addEventListener('change', () => updateHandoff(true));
    });
    brief.addEventListener('input', () => {
      briefEdited = true;
      if (briefStale) q('[data-rgl-review]').checked = false;
      updateHandoff();
    });
    q('[data-rgl-rebuild]').addEventListener('click', () => {
      if (briefEdited) previousBrief = brief.value;
      briefEdited = false;
      briefStale = false;
      q('[data-rgl-review]').checked = false;
      q('[data-rgl-undo]').hidden = !previousBrief;
      updateHandoff();
      report(t.brief_rebuilt);
    });
    q('[data-rgl-undo]').addEventListener('click', () => {
      brief.value = previousBrief;
      briefEdited = true;
      briefStale = true;
      q('[data-rgl-review]').checked = false;
      q('[data-rgl-undo]').hidden = true;
      updateHandoff();
      report(t.brief_restored);
    });
    wa.addEventListener('click', event => {
      if (!selected.length) { event.preventDefault(); report(t.minimum); }
      if (briefStale && !q('[data-rgl-review]').checked) {
        event.preventDefault();
        q('[data-rgl-review]').reportValidity();
      }
      const invalidPreference = [...fields.values()].find(field => !field.checkValidity());
      if (invalidPreference) { event.preventDefault(); invalidPreference.reportValidity(); }
    });
    form.addEventListener('submit', event => {
      updateHandoff();
      if (!selected.length || selected.length > 3) {
        event.preventDefault();
        report(t.minimum);
        q('#rgl-stones').scrollIntoView({ block: 'start', behavior: 'auto' });
        q('[data-rgl-search]').focus({ preventScroll: true });
      }
    });
    all('[data-rgl-enhanced]').forEach(node => { node.hidden = false; });
    renderSelection();
    filter();
  };
  const initialize = scope => scope.querySelectorAll('[data-rgl]').forEach(mount);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();


  } catch(e) { console.error(e); }
})();
})();
